module.exports = __webpack_public_path__ + "static/sako-3cb6a278027265a899b8e60f0b5e1d91.png";